import request from '@/utils/request';

//频道栏目模块
export async function sections(params: {
  type: string;
  id: number;
}): Promise<any> {
  return request(`/api/v1/${params.type}/${params.id}`);
}
